import React, { useMemo } from "react";

import DiscoverChatbotCardSkeleton from "@/pages/Discover/components/DiscoverChatbotCardSkeleton";

type DiscoverRowSkeletonsProps = {
  count: number;
};

const DiscoverRowSkeletons = ({ count }: DiscoverRowSkeletonsProps) => {
  const skeletonKeys = useMemo(() => {
    const keys: string[] = [];
    for (let index = 0; index < count; index += 1) {
      keys.push(`discover-skeleton-${index}`);
    }
    return keys;
  }, [count]);

  return (
    <>
      {skeletonKeys.map((skeletonKey) => (
        <DiscoverChatbotCardSkeleton key={skeletonKey} />
      ))}
    </>
  );
};

export default React.memo(DiscoverRowSkeletons);
